export const getApiUXHeader = (tokenSesion: string, authorization: string = "") => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let parametroURL = urlParams.get('parametro');
      if(!parametroURL){
            const partsUrl = window.location.pathname.split("/");
            const secondPath = partsUrl.length > 0? partsUrl[1] : "";
            if(secondPath === "error"){
                  parametroURL = partsUrl[partsUrl.length - 1];
            }else{
                  parametroURL = "";
            }
      }
      const decodeParam = parametroURL? atob(parametroURL!) : "{}";
      const {uniqueId, codigoAplicacion} = JSON.parse(decodeParam);

      
      return {
            "Transaccion-Id": uniqueId,
            "Aplicacion-Id": import.meta.env.VITE_APPLICATION_ID,
            "Nombre-Aplicacion": import.meta.env.VITE_APPLICATION_NAME,
            "Usuario-Consumidor-Id": "FirmaElectronica",
            "Nombre-Servicio-Consumidor": import.meta.env.VITE_NAME_SERVICE_CONSUMED,
            "Ocp-Apim-Subscription-Key": import.meta.env.VITE_SUBSCRIPTION_KEY,
            "Token-Sesion": tokenSesion,
            "Content-Type": "application/json",
            "Authorization": authorization,
            "Codigo-Aplicacion-Cliente": codigoAplicacion
      };
}